
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"dragHandle.title":"Verschieben","multipleRowsDragPreview.label_one":"{{count}} Element","multipleRowsDragPreview.label_other":"{{count}} Elemente"},"en":{"dragHandle.title":"Move","multipleRowsDragPreview.label_one":"{{count}} Element","multipleRowsDragPreview.label_other":"{{count}} Elements"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();